<template>
  <b-badge :variant="resolveColor"> {{ resolveLabel }} </b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  props: {
    value: String | Number,
  },
  computed: {
    resolveLabel() {
      return this.value === "governmental"
        ? "حكومية"
        : this.value === "spiritual"
        ? "روحية"
        : this.value === "ngo"
        ? "منظمة غير حكومية"
        : "خاصة"
    },
    resolveColor() {
      return this.value === "governmental"
        ? "light-primary"
        : this.value === "spiritual"
        ? "light-success"
        : this.value === "ngo"
        ? "light-danger"
        : "light-secondary"
    },
  },
};
</script>
